export function formatDate(date: string) {
    if (!date) return "-";
    return new Date(date).toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hourCycle: 'h24',
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: 'shortOffset',
    });
}